/**
 * @generated SignedSource<<7b48702e838ab2e4aeb784aa0970388e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CommentAddFragment$data = {
  readonly assignedToId: UUID | null | undefined;
  readonly name: string;
  readonly rowId: UUID;
  readonly " $fragmentType": "CommentAddFragment";
};
export type CommentAddFragment$key = {
  readonly " $data"?: CommentAddFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CommentAddFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CommentAddFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assignedToId",
      "storageKey": null
    }
  ],
  "type": "Flow",
  "abstractKey": null
};

(node as any).hash = "605b0f0b23ddb02db400c884712dc906";

export default node;
